<template>
  <div>
    <div class="row g-3">
      <div class="col-lg-7">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="fw-bold mb-1">Gerar arquivo</h5>
            <p class="ck-subtitulo">Arquivos no leiaute da Portaria MTP nº 671/2021 para entrega ao Auditor-Fiscal do Trabalho (art. 81 e 85).</p>

            <label>Tipo de arquivo</label>
            <div class="tipos">
              <button v-for="t in tipos" :key="t.valor" type="button" :class="['tipo', { sel: tipo === t.valor }]" @click="tipo = t.valor">
                <strong>{{ t.nome }}</strong>
                <small>{{ t.desc }}</small>
              </button>
            </div>

            <div class="row g-2 mt-1">
              <div class="col-md-6">
                <label>Filial / estabelecimento</label>
                <select v-model.number="idfilial" class="form-select">
                  <option :value="0" disabled>Selecione</option>
                  <option v-for="f in filiais" :key="f.id" :value="f.id">{{ f.text }}</option>
                </select>
              </div>
              <div class="col-md-3 col-6">
                <label>De</label>
                <input type="date" v-model="datainicio" class="form-control">
              </div>
              <div class="col-md-3 col-6">
                <label>Até</label>
                <input type="date" v-model="datafim" class="form-control">
              </div>
            </div>
            <div class="atalhos">
              <button class="btn btn-sm btn-light" @click="periodo('mes')">Este mês</button>
              <button class="btn btn-sm btn-light" @click="periodo('anterior')">Mês anterior</button>
              <button class="btn btn-sm btn-light" @click="periodo('ano')">Ano atual</button>
            </div>

            <button class="btn btn-info btn-lg w-100 mt-3" @click="gerar" :disabled="gerando">
              <span v-if="gerando" class="spinner-border spinner-border-sm"></span>
              <i v-else class="bi bi-download"></i> Gerar e baixar
            </button>

            <div v-if="aviso" class="alert alert-warning mt-3 mb-0 small"><i class="bi bi-exclamation-triangle"></i> {{ aviso }}</div>
            <div v-if="ultimo" class="alert alert-success mt-3 mb-0 small">
              <i class="bi bi-check-circle"></i> {{ ultimo.nome }} gerado<span v-if="ultimo.assinado"> com assinatura <b>{{ ultimo.nomeassinatura }}</b></span>.
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-5">
        <div class="card mb-3">
          <div class="card-body">
            <h5 class="fw-bold mb-1">Integridade dos registros</h5>
            <p class="ck-subtitulo">Recalcula o código hash encadeado (SHA-256) de todas as marcações da filial e procura lacunas na sequência de NSR.</p>
            <button class="btn btn-outline-primary w-100" @click="verificar" :disabled="verificando || !idfilial">
              <span v-if="verificando" class="spinner-border spinner-border-sm"></span>
              <i v-else class="bi bi-shield-check"></i> Verificar integridade
            </button>
            <div v-if="integridade" class="resultado" :class="integridade.integra ? 'ok' : 'falha'">
              <strong>{{ integridade.integra ? 'Cadeia íntegra' : 'Divergência encontrada' }}</strong>
              <ul>
                <li>{{ integridade.verificadas }} marcação(ões) verificadas · último NSR {{ integridade.ultimo_nsr }}</li>
                <li v-if="integridade.legado">{{ integridade.legado }} registro(s) anteriores à atualização (sem dados para recálculo)</li>
                <li v-if="integridade.falhas.length">Hash divergente nos NSR: {{ integridade.falhas.join(', ') }}</li>
                <li v-if="integridade.lacunas_nsr.length">NSR sem registro: {{ integridade.lacunas_nsr.slice(0, 20).join(', ') }}{{ integridade.lacunas_nsr.length > 20 ? '…' : '' }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body small ajuda">
            <h6 class="fw-bold">O que vai em cada arquivo</h6>
            <p><b>AFD</b> · gerado pelo REP-P a partir das marcações originais (registros tipo 1, 2, 5, 7 e 9). Inclusões feitas pelo RH <u>não</u> entram no AFD.</p>
            <p><b>AEJ</b> · gerado pelo programa de tratamento: vínculos, horário contratual, marcações originais, incluídas e desconsideradas (com motivo), ausências e identificação do PTRP.</p>
            <p class="mb-0"><b>Assinatura</b> · os dois arquivos acompanham um <code>.p7s</code> (CAdES) assinado com o certificado ICP-Brasil do desenvolvedor, quando configurado no servidor.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Eu sou o caminho, a verdade e a vida. Ninguém vem ao Pai senão por mim. (João 14:6);
import axios from 'axios'
import util from '../util.js'

function iso(d) { return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().substring(0, 10) }

export default {
  name: 'exportardados',
  data() {
    const hoje = new Date()
    return {
      tipos: [
        { valor: '0', nome: 'AFD', desc: 'Arquivo Fonte de Dados (Anexo V)' },
        { valor: '1', nome: 'AEJ', desc: 'Arquivo Eletrônico de Jornada (Anexo VI)' },
        { valor: '3', nome: 'Planilha CSV', desc: 'Conferência interna, sem valor fiscal' },
      ],
      tipo: '0',
      idfilial: 0,
      filiais: [],
      datainicio: iso(new Date(hoje.getFullYear(), hoje.getMonth(), 1)),
      datafim: iso(hoje),
      gerando: false,
      verificando: false,
      aviso: '',
      ultimo: null,
      integridade: null,
    }
  },
  async mounted() {
    const r = await axios.get(util.servidor + '/controller/select2sql.php', {
      params: { idempresa: this.$store.state.usuario.idempresa, token: util.token(), tabela: 'tbfiliais' },
    }).catch(() => ({ data: [] }))
    this.filiais = Array.isArray(r.data) ? r.data : []
    if (this.filiais.length === 1) this.idfilial = this.filiais[0].id
  },
  methods: {
    periodo(qual) {
      const h = new Date()
      if (qual === 'mes') { this.datainicio = iso(new Date(h.getFullYear(), h.getMonth(), 1)); this.datafim = iso(h) }
      if (qual === 'anterior') { this.datainicio = iso(new Date(h.getFullYear(), h.getMonth() - 1, 1)); this.datafim = iso(new Date(h.getFullYear(), h.getMonth(), 0)) }
      if (qual === 'ano') { this.datainicio = iso(new Date(h.getFullYear(), 0, 1)); this.datafim = iso(h) }
    },
    baixar(base64, nome, tipo) {
      const bin = atob(base64)
      const bytes = new Uint8Array(bin.length)
      for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i)
      const url = URL.createObjectURL(new Blob([bytes], { type: tipo }))
      const a = document.createElement('a')
      a.href = url; a.download = nome
      document.body.appendChild(a); a.click(); a.remove()
      setTimeout(() => URL.revokeObjectURL(url), 2000)
    },
    async gerar() {
      if (!this.idfilial) return util.notif('error', 'Atenção', 'Selecione a filial.')
      if (!this.datainicio || !this.datafim || this.datainicio > this.datafim) return util.notif('error', 'Atenção', 'Informe um período válido.')
      this.gerando = true
      this.aviso = ''
      this.ultimo = null
      try {
        const r = await util.reqaxios([
          { parametro: 'op', valor: 'gerararquivo' },
          { parametro: 'idempresa', valor: this.$store.state.usuario.idempresa },
          { parametro: 'idfilial', valor: this.idfilial },
          { parametro: 'datainicio', valor: this.datainicio },
          { parametro: 'datafim', valor: this.datafim },
          { parametro: 'tipo', valor: this.tipo },
        ], 'post', util.servidor + '/controller/exportarregistros.php')
        const d = r.data
        if (!d || !d.sucesso) return util.notif('error', 'Não foi possível gerar', (d && d.mensagem) || String(d).replace(/^E - /, ''))
        this.baixar(d.arquivo, d.nome, d.tipo === 'text/csv' ? 'text/csv' : 'text/plain;charset=iso-8859-1')
        if (d.assinado) setTimeout(() => this.baixar(d.assinatura, d.nomeassinatura, 'application/pkcs7-signature'), 400)
        this.aviso = d.aviso || ''
        this.ultimo = d
      } finally {
        this.gerando = false
      }
    },
    async verificar() {
      this.verificando = true
      try {
        const r = await util.reqaxios([
          { parametro: 'op', valor: 'verificarcadeia' },
          { parametro: 'idempresa', valor: this.$store.state.usuario.idempresa },
          { parametro: 'idfilial', valor: this.idfilial },
          { parametro: 'datainicio', valor: this.datainicio },
          { parametro: 'datafim', valor: this.datafim },
        ], 'post', util.servidor + '/controller/exportarregistros.php')
        if (r.data && r.data.sucesso) this.integridade = r.data
        else util.notif('error', 'Atenção', (r.data && r.data.mensagem) || 'Falha na verificação.')
      } finally {
        this.verificando = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.tipos { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; margin-bottom: 8px; }
@media (max-width: 640px) { .tipos { grid-template-columns: 1fr; } }
.tipo { border: 2px solid var(--ck-borda); background: #fff; border-radius: 12px; padding: 12px; text-align: left; display: flex; flex-direction: column; }
.tipo strong { font-size: 1rem; }
.tipo small { color: var(--ck-texto-2); font-size: .76rem; }
.tipo.sel { border-color: var(--ck-primaria); background: var(--ck-primaria-suave); }
.atalhos { display: flex; gap: 6px; margin-top: 8px; flex-wrap: wrap; }
.resultado { margin-top: 12px; border-radius: 10px; padding: 12px 14px; font-size: .86rem; }
.resultado.ok { background: #e3f4ea; color: #1e5e3c; }
.resultado.falha { background: #fdecea; color: #8e2a1f; }
.resultado ul { margin: 6px 0 0; padding-left: 18px; }
.ajuda p { color: var(--ck-texto-2); }
</style>
